import React, { useState, useEffect, useRef } from 'react';
import './chat-widget.css';
import { useSelector } from 'react-redux';

const ChatWidget = ({ onSendMessage, onClose }) => {
  const activeDetail = useSelector((state) => state?.assistants?.activeDetail);

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
//   console.log('Active Detail:', activeDetail?.details?.name);

  const messagesEndRef = useRef(null);

  // Three dot loading animation component
  const TypingIndicator = () => (
    <div className="chat-bubble assistant">
      <div className="typing-indicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessage = { role: 'user', content: input };
    const updatedMessages = [...messages, newMessage];
    setMessages(updatedMessages);
    setInput('');
    setLoading(true);

    try {
      const reply = await onSendMessage([...updatedMessages, newMessage]);
      setMessages([...updatedMessages, { role: 'assistant', content: reply }]);
    } catch (error) {
      setMessages([
        ...updatedMessages,
        { role: 'assistant', content: 'Oops! Something went wrong.' },
      ]);
    }

    setLoading(false);
  };

  const toggleTheme = () => setIsDarkMode((prev) => !prev);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  // Auto-scroll to the latest message
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="chat-modal-overlay" onClick={onClose}>
      <div
        className="chat-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <button
            style={{
              color: '#fff',
              backgroundColor: '#555',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              fontSize: '20px',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
              transition: 'background-color 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '30px',
            }}
            onClick={onClose}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#444')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#555')}
          >
            &times;
          </button>
        </div>

        {/* Chat Card */}
        <div className="chat-card">
        <div className="chat-header">
        {/* <div>Welcome to {activeDetail?.details?.name} Chat Support</div> */}
       
      </div>
          <div className="chat-messages">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={`chat-bubble ${msg.role === 'user' ? 'user' : 'assistant'}`}
              >
                {msg.content}
              </div>
            ))}
            {loading && <TypingIndicator />}
            <div ref={messagesEndRef} />
          </div>

          <div className="chat-input">
            <input
              type="text"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
            />
            <button onClick={sendMessage}>Send</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatWidget;
